import React, { useEffect, useState } from 'react';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import { API_URL } from '../../Constants';
import SideDrawer from '../header/SideDrawer';
import Paper from '@mui/material/Paper';
import { Box, InputAdornment } from '@material-ui/core';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { axiosClient } from '../AxiosClient';


let apiUrl = API_URL;


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const fondosGarantias = ["FGA", "Figarantias"];

export default function ModifyParameters() {

    const [interestRateActual, setInterestRateActual] = useState(1.93);
    const [tasaMoratoriaActual, setTasaMoratoriaActual] = useState("");
    const [tarifaFgaActual, setTarifaFgaActual] = useState("");
    const [seguroVidaDeudorActual, setSeguroVidaDeudorActual] = useState("");
    const [interestRate, setInteresRate] = useState();
    const [tasaMoratoriaAnual, setTasaMoratoriaAnual] = useState();
    const [interesConsumoActual, setInteresConsumoActual] = useState("");
    const [interesConsumoBajoMontoActual, setInteresConsumoBajoMontoActual] = useState("");
    const [maximosCreditosActual, setMaximosCreditosActual] = useState("");
    const [cellphoneAdminCurrent, setCellphoneAdminCurrent] = useState("");
    const [cellphoneAdmin, setCellphoneAdmin] = useState("");
    const [cellphones, setCellphones] = useState([])
    const [tarifaFga, setTarifaFga] = useState();
    const [seguroVidaDeudor, setSeguroVidaDeudor] = useState();
    const [fondoGarantia, setFondoGarantia] = useState();
    const [fondoGarantiasCurrent, setFondoGarantiasCurrent] = useState("");
    
    const [newItem, setNewItem] = useState();


    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }

        axiosClient.get('/v1/parameters')
        .then(response => {
            console.log(response.data);
            setInterestRateActual(response.data.interestRate);
            setTasaMoratoriaActual(response.data.tasaMoratoriaAnual);
            setTarifaFgaActual(response.data.tarifaFga);
            setSeguroVidaDeudorActual(response.data.seguroVidaDeudor);
            setCellphoneAdminCurrent(response.data.cellphoneAdmin);
            setFondoGarantiasCurrent(response.data.fondoGarantia);
            setInteresConsumoActual(response.data.tasaInteresConsumo);
            setInteresConsumoBajoMontoActual(response.data.tasaInteresConsumoBajoMonto);
            setMaximosCreditosActual(response.data.creditosMaximosTasaBajoMonto);
        })
        .catch(error => {
            console.log("Bad petition: " + error.message);
        });
    }, [newItem])

    useEffect(() => {
        axiosClient.get('/v1/users/list')
        .then(response => {
            setCellphones(response.data);
        })
        .catch(error => {
            console.log("Bad petition: " + error.message);
        });
    }, [])

    const handleBackToHome = () => {
        window.location = '/general-admin';
    }

    const handleModifyItem = (name, item, setItem) => {
        // let newInterestRate = document.getElementById('newInterestRate').value;
    
        if(item != "" && item){
            if(item.substring(0,2) == '57' && item.length != 12) {
                alert("Ingresa un valor válido!")
            } else {
                let parameterRequest = {}
            parameterRequest[name] = item
            axiosClient.patch('/v1/parameters', parameterRequest, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                console.log(response.data.uuid);
                setNewItem(item + name);
                setItem('');
            })
            .catch(error => {
                console.log('Hubo un problema con la petición Axios: ' + error.message);
            });
            }
        }else{
            alert("Ingresa un valor válido!")
        }
        
    }

    const handleChangeInterestRate = (event) => {
        setInteresRate(event.target.value)
    }

    const handleChangeAdminCellphone = (event) => {
        setCellphoneAdmin(event.target.value)
    }

    const handleChangeFondoGarantia = (event) => {
        setFondoGarantia(event.target.value)
    }

    const handleChangeTasaMoratoriaAnual = (event) => {
        setTasaMoratoriaAnual(event.target.value)
    }

    const handleChangeTarifaFga = (event) => {
        setTarifaFga(event.target.value)
    }
    
    const handleChangeSeguroVidaDeudor = (event) => {
        setSeguroVidaDeudor(event.target.value)
    }

    console.log(cellphoneAdmin)

    return (
        <React.Fragment>
            {/* <Header name={"admin"} position="fixed" /> */}
            {/* <SideDrawer currentPage={'Parametros'}></SideDrawer> */}
            {/* <br /><br /> */}
            <Box margin={1}>
            <Item>.</Item>
            <Item></Item>
            <Box mt={8} ml={4} mr={4}>
                <h1>Parámetros Globales</h1>
                <Grid container spacing={2} mt={4} mb={4}>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem', '&>h3': {textAlign: 'start', marginLeft: '4vw'}}}>
                            <h2>Tasa de interés</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={interestRateActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={interestRate} onChange={handleChangeInterestRate}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('interestRate', interestRate, setInteresRate)} sx={{marginBottom: '1rem'}}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                    <Item sx={{padding: '1rem'}}>
                            <h2>Tasa moratoria anual</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={tasaMoratoriaActual} disabled ></TextField>
                                    <TextField label='Valor nuevo' value={tasaMoratoriaAnual} onChange={handleChangeTasaMoratoriaAnual}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('tasaMoratoriaAnual', tasaMoratoriaAnual, setTasaMoratoriaAnual)} sx={{marginBottom: '1rem'}}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem'}}>
                            <h2>Tarifa Fga</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={tarifaFgaActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={tarifaFga} onChange={handleChangeTarifaFga}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('tarifaFga', tarifaFga, setTarifaFga)}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem'}}>
                            <h2>Seguro de vida deudor</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={seguroVidaDeudorActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={seguroVidaDeudor} onChange={handleChangeSeguroVidaDeudor}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('seguroVidaDeudor', seguroVidaDeudor, setSeguroVidaDeudor)}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem'}}>
                            <h2>Celular Admin</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={cellphoneAdminCurrent} disabled></TextField>
                                    <Grid sx={{width: '14vw'}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="cellphone">Valor nuevo</InputLabel>
                                            <Select labelId='cellphone' id='cellphone' label="Valor nuevo" value={cellphoneAdmin} onChange={handleChangeAdminCellphone}>
                                                {cellphones.map(cellphone => (
                                                    <MenuItem key={cellphone?.uuid} value={'57'+cellphone?.cellphone}>{'57'+cellphone?.cellphone}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        
                                    </Grid>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('cellphoneAdmin', cellphoneAdmin, setCellphoneAdmin)}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem'}}>
                            <h2>Fondo de Garantías</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={fondoGarantiasCurrent} disabled></TextField>
                                    <Grid sx={{width: '14vw'}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="fondoGarantia">Valor nuevo</InputLabel>
                                            <Select labelId='fondoGarantia' id='fondoGarantia' label="Valor nuevo" value={fondoGarantia} onChange={handleChangeFondoGarantia}>
                                                {fondosGarantias.map(fondoGarantia => (
                                                    <MenuItem key={fondoGarantia} value={fondoGarantia}>{fondoGarantia}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        
                                    </Grid>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('fondoGarantia', fondoGarantia, setFondoGarantia)}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem', '&>h3': {textAlign: 'start', marginLeft: '4vw'}}}>
                            <h2>Tasa de interés consumo</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={interesConsumoActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={interestRate} onChange={handleChangeInterestRate}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('interestRate', interestRate, setInteresRate)} sx={{marginBottom: '1rem'}}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem', '&>h3': {textAlign: 'start', marginLeft: '4vw'}}}>
                            <h2>Tasa de interés bajo consumo</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={interesConsumoBajoMontoActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={interestRate} onChange={handleChangeInterestRate}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('interestRate', interestRate, setInteresRate)} sx={{marginBottom: '1rem'}}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                    <Grid item xs={6}>
                        <Item sx={{padding: '1rem', '&>h3': {textAlign: 'start', marginLeft: '4vw'}}}>
                            <h2>Créditos máximos credito bajo monto</h2>
                            <Box marginBottom={'1rem'} display={'flex'} justifyContent={'center'} gridGap={'1rem'}>
                                <FormControl sx={{display: 'flex', justifyContent: 'center', gap: '1rem', flexDirection: 'row'}}>
                                    <TextField label='Valor actual' value={interestRateActual} disabled></TextField>
                                    <TextField label='Valor nuevo' value={interestRate} onChange={handleChangeInterestRate}></TextField>
                                </FormControl>
                            </Box>
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleModifyItem('interestRate', interestRate, setInteresRate)} sx={{marginBottom: '1rem'}}>
                                Modificar
                            </ButtonPrincipal>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
            </Box>


        </React.Fragment>
    );
}